<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>党务公开</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="contrl_bar">
						<el-button type="primary" size="small" @click="goedit">编辑</el-button>
						<el-button type="primary" size="small"
						@click="$router.go(-1)">返回上级</el-button>
					</div>
					<div class="tops">
						<div class="top_left">
							<img v-if="datas.sz_img" :src="datas.sz_img" alt="">
							<img v-else src="@/assets/images/nodata.jpg" >
						</div>
						<div class="top_right">
							<div class="detail_title">{{datas.title}}</div>
							<div class="pub_time">分类：{{datas.class_id}}</div>
							<div class="pub_time">时间：{{datas.day!=''?datas.day:'暂无发布时间'}}</div>
						</div>
					</div>
					<div class="content">
						<div>内容：</div>
						<div class="content_item" 
						v-if="datas.content!=null && datas.content!=''" v-html="datas.content"></div>
						<div class="nodata" v-else>
							<img src="@/assets/images/nodata.jpg" >
						</div>
					</div>
					<div class="fileList"
						style="margin-left:0;margin-top:20px;"
						v-if="datas.files.length > 0">
						<div style="margin-bottom:10px">附件：</div>
						<div class="fileItem" :key="index" v-for="(item,index) in datas.files">
							<div class="fileIcon" v-if="item.bsid == 8"><img src="@/assets/images/pdfBg.png" ></div>
							<div class="fileIcon" v-if="item.bsid == 3"><img src="@/assets/images/videoBg.png" ></div>
							<div class="fileIcon" v-if="item.bsid == 1"><img src="@/assets/images/pptBg.png" ></div>
							<div class="fileIcon" v-if="item.bsid == 2"><img src="@/assets/images/pdfBg.png" ></div>
							<div class="fileName">{{item.title}}</div>
							<div class="fileDel" title="下载" @click="download(ment_url)">
								<i class="el-icon-download"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import detail from './mixins/detail.js'
	export default {
		mixins:[detail]
	}
</script>

<style lang="scss" scoped>
	.tops{
		display: flex;
		margin-bottom: 20px;
		.top_left{
			height: 150px;
			width: 220px;
			border-radius: 8px;
			margin-right: 15px;
			img{
				border-radius: inherit;
				width: 100%;
				height: 100%;
			}
		}
	}
	.wrap{
		width: 100%;
		position: relative;
		color: $index_color;
		font-size: index_size1;
		.detail_title{
			font-size: 18px;
			font-weight: bold;
			margin-bottom: $indexMarginTop;
		}
		.pub_time{
			margin-bottom: 10px;
		}
		.content_item{
			width: 70%;
			line-height: 40px;
			padding: 50px 50px;
			box-sizing: border-box;
			background: #FAFBFC;
			margin-top: 10px;
			border: 1px solid #DDE2EE;
			img{
				width: 100%;
				margin: 10px auto;
			}
		}
	}
</style>
